"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RightPanelType = exports.MiddlePanelType = exports.LeftPanelType = void 0;
var LeftPanelType;
(function (LeftPanelType) {
    LeftPanelType[LeftPanelType["None"] = 0] = "None";
    LeftPanelType[LeftPanelType["Chats"] = 1] = "Chats";
    LeftPanelType[LeftPanelType["JoinGroupChat"] = 2] = "JoinGroupChat";
    LeftPanelType[LeftPanelType["NewDirectChat"] = 3] = "NewDirectChat";
    LeftPanelType[LeftPanelType["NewGroupChat"] = 4] = "NewGroupChat";
})(LeftPanelType = exports.LeftPanelType || (exports.LeftPanelType = {}));
var MiddlePanelType;
(function (MiddlePanelType) {
    MiddlePanelType[MiddlePanelType["None"] = 0] = "None";
    MiddlePanelType[MiddlePanelType["Messages"] = 1] = "Messages";
})(MiddlePanelType = exports.MiddlePanelType || (exports.MiddlePanelType = {}));
var RightPanelType;
(function (RightPanelType) {
    RightPanelType[RightPanelType["None"] = 0] = "None";
    RightPanelType[RightPanelType["AddParticipants"] = 1] = "AddParticipants";
    RightPanelType[RightPanelType["Participants"] = 2] = "Participants";
})(RightPanelType = exports.RightPanelType || (exports.RightPanelType = {}));
